import { FC } from 'react';
import Typography from '@ixigo/iui/Typography';

type StatusCardProps = {
    isResolved: boolean;
    message: string;
};

const StatusCard: FC<StatusCardProps> = ({ isResolved, message }) => (
    <div
        className={`p-15 rounded-[10px] ${
            isResolved ? 'bg-success-50 border border-success-300' : 'bg-sky-50 border border-blue-200'
        }`}
    >
        <Typography variant='body-sm' className={`text-center ${isResolved ? 'text-green-600' : 'text-blue-600'}`}>
            {message}
        </Typography>
    </div>
);

export default StatusCard;
